import React, { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import api from "../../../lib/api";
import { lbl } from "../shared";

export const AICopyButton = ({ p, setP }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    const name = p.name_en || p.name_ar;
    if (!name) return toast.error("أدخل اسم العطر أولاً · Enter the perfume name first");
    if ((p.description_en || p.description_ar) && !window.confirm("سيتم استبدال الأوصاف الحالية. متابعة؟ · Replace current descriptions?")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/ai/product-copy", {
        name, notes: (p.notes_en || []).join(", "), family: p.olfactive_family_en, concentration: p.parfum_type,
        accords: (p.accords || []).map((a) => a.name_en).join(", "), hints: p.short_en || p.short_ar,
      });
      setP((prev) => ({ ...prev, ...Object.fromEntries(Object.entries(data).filter(([, v]) => v)) }));
      toast.success("تمت كتابة الأوصاف بالعربية والإنجليزية · Copy generated");
    } catch (e) {
      toast.error(e.response?.data?.detail || "تعذّر إنشاء الوصف");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="md:col-span-2 border border-[#262421] p-4 flex items-center justify-between gap-3 flex-wrap" data-testid="ai-copy-box">
      <div>
        <p className={lbl}>AI Copywriter · كاتب الأوصاف الذكي</p>
        <p className="text-xs text-[#8A857D] mt-1">يكتب الوصف المختصر والوصف الكامل وملف الرائحة بالعربية والإنجليزية من الاسم والنوتات.</p>
      </div>
      <button type="button" onClick={run} disabled={busy} data-testid="ai-copy-btn"
        className="flex items-center gap-2 text-[10px] uppercase tracking-widest border border-[#C49A6C] text-[#C49A6C] px-4 py-2 hover:bg-[#C49A6C] hover:text-[#0B0A08] transition-colors disabled:opacity-40">
        <Sparkles size={14} /> {busy ? "جارٍ الكتابة…" : "اكتب الأوصاف"}
      </button>
    </div>
  );
};
